module.exports = {"TXTWCL_Continue":{"id":"TXTWCL_Continue","defaultMessage":"Folytatás","track":"Continue"}}